module.exports = __webpack_public_path__ + "static/media/kredyt_28.b9f7a31d.png";